export const environment = {
  production: true,
  local: false,
  baseURL: 'https://www.packboo.com/api',
  apiDoc: 'https://www.packboo.com/swagger-ui/index.html',
  version: require('../../package.json').version
};
